import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10 13H1C0.447715 13 0 13.4477 0 14V23C0 23.5523 0.447715 24 1 24H10C10.5523 24 11 23.5523 11 23V14C11 13.4477 10.5523 13 10 13Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23 13H14C13.4477 13 13 13.4477 13 14V23C13 23.5523 13.4477 24 14 24H23C23.5523 24 24 23.5523 24 23V14C24 13.4477 23.5523 13 23 13Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.5 0H7.5C6.94772 0 6.5 0.447715 6.5 1V10C6.5 10.5523 6.94772 11 7.5 11H16.5C17.0523 11 17.5 10.5523 17.5 10V1C17.5 0.447715 17.0523 0 16.5 0Z"
    }, null, -1)
  ])))
}
export default { render: render }